/* Northsheep — photo zoom on the product gallery.

   Hides are bought for their marks: a scar, a brand, how the hair lies.

   WITH A MOUSE (screens 750px and wider):
   FRAME (default): resting on a photo for 150ms zooms the whole frame to 2×
   and the view follows the mouse. LENS (option): a round 240px lens at 2×
   follows it. (The frame used to lift with the zoom; the lift was retired on
   16 Sep 2026 and its class is no longer written.) Clicking the photo opens
   nothing; the keyboard (Enter/Space, event.detail 0) still opens the
   full-screen view.

   ON A TOUCH SCREEN (owner, 2026-09-14): tap the photo and it lifts and zooms
   to 2× inside its own frame, centred where it was tapped. Drag a finger to
   look around. Tap again, or the small × in the corner, to return. While
   zoomed the photo takes the finger (touch-action: none), so the gallery does
   not swipe and the page does not scroll from the photo; tap out first.

   Shared rules:
   - Mouse vs touch is decided from the pointer that actually acted
     (pointerType, remembered from pointerdown because iOS Safari's click
     events carry none) — never from what the device says its primary pointer
     is: touchscreen laptops answer "coarse" and the zoom silently vanished.
   - The zoom layers are EMPTY divs, and Dawn's base.css hides div:empty; the
     CSS gives them display:block explicitly (that trap bit once).
   - The sharper image (3000px) is requested on first use only.
   - Everything is delegated from document: Dawn replaces the gallery markup on
     a variant change, and bound listeners would be lost with it.
   Revert: Theme editor → product section → "Photo zoom on desktop". */
(function () {
  if (window.__nsMagnifier) return;
  window.__nsMagnifier = true;


  var cfg = document.querySelector('script[data-ns-zoom-style]');
  var STYLE = cfg && cfg.getAttribute('data-ns-zoom-style') === 'lens' ? 'lens' : 'frame';
  var CLOSE_LABEL = (cfg && cfg.getAttribute('data-ns-close-label')) || 'Close';
  var MIN_WIDTH = 750;
  var ZOOM = 2;
  var LENS = 240;
  var GRACE = 8;
  /* Rest on the photo this long before it zooms (owner, 2026-09-16: it used to
     fire the moment the cursor touched the photo, so sweeping across it on the
     way to the buy button zoomed and un-zoomed for nothing). 150ms is below the
     point where a deliberate hover feels laggy — the same figure the thumbnail
     strip uses. Moving around INSIDE the photo stays instant: the wait is only
     for arriving. */
  var DWELL = 150;

  var lens = null;
  var active = null; // hover state: { opener, img, layer, slot, armed }
  var armTimer = 0;
  var last = null;
  var tap = null; // touch state
  var drag = null;
  var suppressClick = false;
  var lastType = '';
  var hiState = {};

  function wideEnough() {
    return window.innerWidth >= MIN_WIDTH;
  }

  function typeOf(e) {
    return e.pointerType || lastType || (wideEnough() ? 'mouse' : 'touch');
  }

  function openerFrom(el) {
    if (!el || !el.closest) return null;
    var o = el.closest('.product__modal-opener--image');
    // The photo's SLOT counts as the photo. On hover the frame rises 5px,
    // uncovering a strip of the slot under it; a pointer there must keep the
    // zoom, or the edge flickers between zoomed and not.
    if (!o) {
      var slot = el.closest('.product__media-item');
      o = slot ? slot.querySelector('.product__modal-opener--image') : null;
    }
    if (!o || o.closest('quick-add-modal') || o.closest('product-modal')) return null;
    return o;
  }

  function hiRes(src) {
    try {
      var u = new URL(src, window.location.href);
      u.searchParams.set('width', '3000');
      return u.toString();
    } catch (e) {
      return src;
    }
  }

  function pickSrc(img) {
    var base = img.currentSrc || img.src;
    var hi = hiRes(base);
    if (hiState[hi] === 'ok') return hi;
    if (!hiState[hi]) {
      hiState[hi] = 'loading';
      var probe = new Image();
      probe.onload = function () {
        hiState[hi] = 'ok';
        if (last) draw(last.x, last.y);
        if (tap && hiRes(tap.img.currentSrc || tap.img.src) === hi) {
          tap.layer.style.backgroundImage = 'url("' + hi + '")';
          tap.layer.__src = hi;
        }
      };
      probe.onerror = function () {
        hiState[hi] = 'fail';
      };
      probe.src = hi;
    }
    return base;
  }

  /* Where the photo itself sits inside the <img> box (object-fit: contain
     leaves empty bands beside or above it). */
  function photoRect(img) {
    var r = img.getBoundingClientRect();
    var nw = img.naturalWidth;
    var nh = img.naturalHeight;
    var fit = window.getComputedStyle(img).objectFit;
    if (!nw || !nh || (fit !== 'contain' && fit !== 'cover')) {
      return { left: r.left, top: r.top, width: r.width, height: r.height, box: r };
    }
    var s = fit === 'contain' ? Math.min(r.width / nw, r.height / nh) : Math.max(r.width / nw, r.height / nh);
    var w = nw * s;
    var h = nh * s;
    return { left: r.left + (r.width - w) / 2, top: r.top + (r.height - h) / 2, width: w, height: h, box: r };
  }

  function clamp(v, lo, hi) {
    return Math.min(hi, Math.max(lo, v));
  }

  function frameLayer(opener) {
    var holder = opener.querySelector('.product__media');
    if (!holder) return null;
    var layer = holder.querySelector('.ns-fzoom');
    if (!layer) {
      layer = document.createElement('div');
      layer.className = 'ns-fzoom';
      layer.setAttribute('aria-hidden', 'true');
      holder.appendChild(layer);
    }
    return layer;
  }

  /* Position the zoomed picture so it never slides away from a frame edge. */
  function placed(px, py, zw, zh, hw, hh) {
    var x = zw >= hw ? clamp(px, hw - zw, 0) : (hw - zw) / 2;
    var y = zh >= hh ? clamp(py, hh - zh, 0) : (hh - zh) / 2;
    return [x, y];
  }

  /* ── Mouse: hover zoom ─────────────────────────────────────────────────── */

  function cancelArm() {
    if (armTimer) {
      clearTimeout(armTimer);
      armTimer = 0;
    }
  }

  function hide() {
    cancelArm();
    if (lens) lens.classList.remove('is-visible');
    if (active) {
      active.opener.classList.remove('ns-zoom-on');
      if (active.layer && !(tap && tap.layer === active.layer)) active.layer.classList.remove('is-visible');
    }
    active = null;
    last = null;
  }

  function hideView() {
    if (lens) lens.classList.remove('is-visible');
    if (active) {
      active.opener.classList.remove('ns-zoom-on');
      if (active.layer) active.layer.classList.remove('is-visible');
    }
  }

  function draw(x, y) {
    if (!active || !last) return;
    var img = active.img;
    if (!document.body.contains(img)) return hide();
    var c = photoRect(img);
    var b = c.box;
    // A few pixels of grace past the photo's edge (owner's idea): the frame
    // lifts 5px on hover, so the pointer can sit just outside the moved photo
    // while still on its slot. Inside the grace band the view holds at the
    // edge instead of switching off.
    var left = Math.max(c.left, b.left);
    var right = Math.min(c.left + c.width, b.right);
    var top = Math.max(c.top, b.top);
    var bottom = Math.min(c.top + c.height, b.bottom);
    var inside = x >= left - GRACE && x <= right + GRACE && y >= top - GRACE && y <= bottom + GRACE;
    if (!inside) return hideView();
    x = clamp(x, left, right);
    y = clamp(y, top, bottom);

    var src = pickSrc(img);
    var zw = c.width * ZOOM;
    var zh = c.height * ZOOM;
    var fx = (x - c.left) / c.width;
    var fy = (y - c.top) / c.height;

    if (STYLE === 'lens') {
      if (!lens) {
        lens = document.createElement('div');
        lens.className = 'ns-mag';
        lens.setAttribute('aria-hidden', 'true');
        document.body.appendChild(lens);
      }
      if (lens.__src !== src) {
        lens.style.backgroundImage = 'url("' + src + '")';
        lens.__src = src;
      }
      lens.style.backgroundSize = zw + 'px ' + zh + 'px';
      lens.style.backgroundPosition = LENS / 2 - fx * zw + 'px ' + (LENS / 2 - fy * zh) + 'px';
      lens.style.transform = 'translate3d(' + (x - LENS / 2) + 'px,' + (y - LENS / 2) + 'px,0)';
      lens.classList.add('is-visible');
    } else {
      var layer = active.layer || (active.layer = frameLayer(active.opener));
      if (!layer) return;
      var holder = layer.parentNode.getBoundingClientRect();
      if (layer.__src !== src) {
        layer.style.backgroundImage = 'url("' + src + '")';
        layer.__src = src;
      }
      var p = placed(x - holder.left - fx * zw, y - holder.top - fy * zh, zw, zh, holder.width, holder.height);
      layer.style.backgroundSize = zw + 'px ' + zh + 'px';
      layer.style.backgroundPosition = p[0] + 'px ' + p[1] + 'px';
      layer.classList.add('is-visible');
    }
    active.opener.classList.add('ns-zoom-on');
    /* No class on the photo's slot any more (audit, 2 Oct 2026): .ns-zoom-lift
       styled nothing since the lift was retired (16 Sep), and writing it on every
       mouse move woke the gallery's selected-photo watcher each time. */
    if (STYLE === 'lens') active.opener.classList.add('ns-zoom-lens');
    last.x = x;
    last.y = y;
  }

  var lastMouseX = -1;
  var lastMouseY = -1;
  function onMove(e) {
    // A finger dragging a tap-zoomed photo is handled by the drag code below.
    if (drag && e.pointerId === drag.id) return onDragMove(e);
    if (typeOf(e) !== 'mouse') return hide();
    /* A MOVE THAT DID NOT MOVE (audit E5, 2 Oct 2026). After a scroll under a
       still cursor the browser reports one, and it brought the zoom back by
       itself - exactly what the scroll handler below promises not to do. */
    if (e.clientX === lastMouseX && e.clientY === lastMouseY) return;
    lastMouseX = e.clientX;
    lastMouseY = e.clientY;
    if (!wideEnough()) return hide();
    var opener = openerFrom(e.target);
    if (!opener) return hide();
    var img = opener.querySelector('.product__media img');
    if (!img || !img.complete || !img.naturalWidth) return hide();
    if (!active || active.opener !== opener) {
      hide();
      active = {
        opener: opener,
        img: img,
        layer: null,
        slot: opener.closest('.product__media-item'),
        armed: false
      };
    }
    active.img = img;
    last = { x: e.clientX, y: e.clientY };

    /* Arriving: sit out the dwell drawing nothing, so a cursor crossing the
       photo leaves no trace at all — no lift, no zoom. Once armed, every later
       move draws immediately, so looking around the hide stays instant. */
    if (!active.armed) {
      if (!armTimer) {
        var arriving = active;
        armTimer = setTimeout(function () {
          armTimer = 0;
          if (active !== arriving || !last) return;
          active.armed = true;
          draw(last.x, last.y);
        }, DWELL);
      }
      return;
    }
    draw(e.clientX, e.clientY);
  }

  /* ── Touch: tap to zoom, drag to look around, tap or × to return ──────── */

  var CLOSE_SVG =
    '<svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true" focusable="false">' +
    '<path d="M3.5 3.5l9 9M12.5 3.5l-9 9" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';

  function tapOut() {
    if (!tap) return;
    tap.layer.classList.remove('is-visible');
    if (tap.slot) tap.slot.classList.remove('ns-tapzoom');
    if (tap.close && tap.close.parentNode) tap.close.parentNode.removeChild(tap.close);
    tap = null;
    drag = null;
  }

  function tapSetPos(px, py) {
    var p = placed(px, py, tap.zw, tap.zh, tap.hw, tap.hh);
    tap.px = p[0];
    tap.py = p[1];
    tap.layer.style.backgroundPosition = tap.px + 'px ' + tap.py + 'px';
  }

  function tapIn(opener, x, y) {
    tapOut();
    var img = opener.querySelector('.product__media img');
    if (!img || !img.naturalWidth) return;
    var layer = frameLayer(opener);
    if (!layer) return;
    var c = photoRect(img);
    var holder = layer.parentNode.getBoundingClientRect();
    var zw = c.width * ZOOM;
    var zh = c.height * ZOOM;
    var fx = clamp((x - c.left) / c.width, 0, 1);
    var fy = clamp((y - c.top) / c.height, 0, 1);
    tap = {
      opener: opener,
      img: img,
      layer: layer,
      slot: opener.closest('.product__media-item'),
      container: opener.closest('.product-media-container') || opener.parentNode,
      zw: zw,
      zh: zh,
      hw: holder.width,
      hh: holder.height,
      px: 0,
      py: 0,
      close: null
    };
    var src = pickSrc(img);
    layer.style.backgroundImage = 'url("' + src + '")';
    layer.__src = src;
    layer.style.backgroundSize = zw + 'px ' + zh + 'px';
    tapSetPos(x - holder.left - fx * zw, y - holder.top - fy * zh);
    layer.classList.add('is-visible');
    if (tap.slot) tap.slot.classList.add('ns-tapzoom');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ns-fzoom-close';
    btn.setAttribute('aria-label', CLOSE_LABEL);
    btn.innerHTML = CLOSE_SVG;
    tap.container.appendChild(btn);
    tap.close = btn;
    placeClose();
  }

  /* KEEP THE × WHERE A THUMB CAN REACH IT (owner, 2026-09-16).

     The button used to sit in the corner of the PHOTO. In the phone filmstrip
     a wide room photo is several screens wide, so that corner is off-screen —
     and while the zoom is open the photo takes the finger (touch-action: none
     in the CSS), so there is no way to scroll over to it. The zoom could only
     be closed by tapping again, which is not obvious.

     So it is placed against the part of the photo that is actually ON SCREEN:
     the right edge clamped to the window, the top clamped to zero. For a photo
     narrower than the screen nothing changes — that is still its own corner.
     Absolute inside the frame rather than fixed: with the drag setting on, the
     slides carry a transform, and a transformed ancestor makes `fixed` measure
     from the slide instead of the window. */
  function placeClose() {
    if (!tap || !tap.close) return;
    /* ONE GAP, BOTH AXES. This used to subtract a hard-coded 44 for a button
       that measured 36 with its border, so it sat 8px from the right and 10px
       from the top — close enough to look like a mistake, which the owner
       spotted. Measuring the button keeps the two equal whatever it is
       restyled to. */
    /* On a phone, the page gutter — so the × sits straight under the "next"
       arrow above the photo, as the camera sits under "previous" (owner,
       23 Sep 2026). northsheep-product.js measures it (window.nsPhotoInset);
       10 wherever there is no gutter to line up with, or no helper. */
    var GAP = (window.nsPhotoInset && tap.container && window.nsPhotoInset(tap.container, 'right')) || 10;
    var btn = tap.close;
    var size = btn.offsetWidth || 40;
    var r = tap.container.getBoundingClientRect();
    var w = window.innerWidth || r.right;
    var right = Math.min(r.right, w);
    var top = Math.max(r.top, 0);
    /* THE GAP IS MEASURED ON THE SCREEN, SO IT MUST BE SOLVED ON THE SCREEN.

       The frame sits on a fractional pixel (measured: left 1.x). An offset of
       a round 10px inside it therefore lands at 10.5 on the screen and paints
       as 11 at the top while the right edge loses the same fraction the other
       way — 9 and 11 around a gap that is supposed to be identical. Rounding
       the offset does not help: the offset was already whole; the fraction is
       in the frame's own origin.

       So pick the screen position first — GAP from the window's right edge,
       GAP below the visible top — and convert to an offset by subtracting the
       frame's fractional origin. Rounding the RESULT of that subtraction is
       what puts the painted edges on whole pixels. */
    var targetX = right - GAP - size;
    var targetY = top + GAP;
    /* AND THE ORIGIN IS INSIDE THE FRAME'S BORDER (23 Sep 2026). An absolute
       child is placed from the PADDING box, and the frame carries a hairline
       (0.67px measured at 2x) — so every offset landed that far right and
       down: the × sat 0.7px off the arrow above it and 1px lower than the
       camera beside it. The frame's inner edge, border included, is what
       gets subtracted.

       And NOT ROUNDED any more. Rounding "on the screen" depends on the
       page's scroll position at that instant, which carries a fraction of a
       pixel — so the × and the camera, placed at different moments, rounded
       half a pixel apart (measured 219.46 against 218.99). Unrounded, both are
       exactly one inset below the same photo edge, whatever the scroll does. */
    var fcs = getComputedStyle(tap.container);
    var ox = r.left + (parseFloat(fcs.borderLeftWidth) || 0);
    var oy = r.top + (parseFloat(fcs.borderTopWidth) || 0);
    btn.style.right = 'auto';
    /* The floor — never nearer than GAP to the frame — is measured from the
       frame's OUTER edge like everything else here. Written as max(GAP, …)
       after the border was subtracted, it bound on every photo and pushed the
       × back down by exactly the border. */
    btn.style.left = Math.max(r.left + GAP, targetX) - ox + 'px';
    btn.style.top = Math.max(r.top + GAP, targetY) - oy + 'px';
  }

  function onDragMove(e) {
    if (!tap) return;
    var dx = e.clientX - drag.x;
    var dy = e.clientY - drag.y;
    if (Math.abs(dx) + Math.abs(dy) > 6) drag.moved = true;
    tapSetPos(drag.px + dx, drag.py + dy);
  }

  function onDragEnd(e) {
    if (!drag || e.pointerId !== drag.id) return;
    if (drag.moved) suppressClick = true;
    drag = null;
  }

  document.addEventListener(
    'pointerdown',
    function (e) {
      lastType = e.pointerType || lastType;
      suppressClick = false;
      if (!tap || e.pointerType === 'mouse') return;
      if (tap.close && tap.close.contains(e.target)) return;
      if (openerFrom(e.target) !== tap.opener) return;
      drag = { id: e.pointerId, x: e.clientX, y: e.clientY, px: tap.px, py: tap.py, moved: false };
    },
    { passive: true, capture: true }
  );

  if (window.PointerEvent) {
    document.addEventListener('pointermove', onMove, { passive: true });
    document.addEventListener('pointerup', onDragEnd, { passive: true });
    document.addEventListener('pointercancel', onDragEnd, { passive: true });
  } else {
    document.addEventListener('mousemove', onMove, { passive: true });
  }

  /* One click handler for both worlds, in the capture phase so it runs before
     Dawn's modal opener. */
  document.addEventListener(
    'click',
    function (e) {
      var closeBtn = e.target.closest ? e.target.closest('.ns-fzoom-close') : null;
      if (closeBtn) {
        e.preventDefault();
        e.stopPropagation();
        tapOut();
        return;
      }
      var opener = openerFrom(e.target);
      if (!opener) return;
      if (e.detail === 0) return; // keyboard: the full-screen view as before

      var type = typeOf(e);
      if (type === 'mouse' && wideEnough()) {
        // Mouse: the hover zoom is the zoom; the click opens nothing.
        if (!e.target.closest('.product__media-toggle')) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return;
      }

      // Touch: tap toggles the in-frame zoom.
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      if (suppressClick) {
        suppressClick = false;
        return;
      }
      if (tap && tap.opener === opener) return tapOut();
      tapIn(opener, e.clientX, e.clientY);
    },
    true
  );

  /* Hover zoom was placed for the old scroll position; drop it until the mouse
     moves again. A tap zoom lives inside the frame and scrolls with it — but
     the × is placed against the window, so it has to be re-placed when the
     page moves under it. */
  /* Published for the filmstrip. The scroll listener below switches the zoom
     off once the strip has ALREADY started moving, so the zoom-out reads as a
     first step and the scroll as a second one — owner: "when i want to scroll
     when i zoom in then first scroll is zooming out and only after that i can
     scroll ... zoom out and scroll at the same time". Calling this from the
     wheel handler puts both in the same frame. */
  window.__nsZoomOff = function () {
    hide();
  };

  /* CAPTURE, on the document — not `window`.

     A scroll event does not bubble, so a listener on window only ever hears
     the page scrolling. Scrolling INSIDE the filmstrip is an element scroll,
     and the zoom stayed on top of photographs that were sliding away under it
     (owner: "if you are activly scrolling it stops the zoom. the same right
     now when we scroll down"). The capture phase runs down from the document
     to whatever scrolled, so this hears both.

     The zoom does not come back on its own afterwards: it re-arms on the next
     real mouse MOVE, and then only after the dwell. Scrolling with a still
     hand therefore leaves the photograph alone, which is the point. */
  document.addEventListener(
    'scroll',
    function () {
      hide();
      placeClose();
    },
    { passive: true, capture: true }
  );
  /* Only a real change of WIDTH closes the zoom (audit E12, 2 Oct 2026). On a
     phone the browser's toolbar collapsing as the page scrolls changes the
     height, and that closed a tap-zoom in the middle of looking around. */
  var lastWidth = window.innerWidth;
  window.addEventListener(
    'resize',
    function () {
      if (window.innerWidth === lastWidth) return;
      lastWidth = window.innerWidth;
      hide();
      tapOut();
    },
    { passive: true }
  );
})();
